"use strict";

exports.__esModule = true;
exports.default = void 0;
var _setBreakpoint = _interopRequireDefault(require("./setBreakpoint"));
var _getBreakpoint = _interopRequireDefault(require("./getBreakpoint"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var _default = {
  setBreakpoint: _setBreakpoint.default,
  getBreakpoint: _getBreakpoint.default
};
exports.default = _default;